// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__381xE","icon":"styles_icon__1DayV"};